import { Grid } from "@mui/material";
import MuiToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import { observer } from "mobx-react";
import TimelinePageStore from "pages/TimelinePage/store/TimelinePageStore";

const StyledToggleButton = styled(MuiToggleButton)(({ color }) => ({
  borderRadius: "0px",
  background: "##F7F7F7",
  fontFamily: "Pretendard",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "12px",
  lineHeight: "12px",
  color: "#ABABAB",
  "&.Mui-selected, &.Mui-selected:hover": {
    color: "#2281D0",
    backgroundColor: "rgba(36, BC, 99, 0.5)",
    border: "1px solid #2281D0",
    borderRadius: "5px",
  },
}));

const theme = createTheme({
  palette: {
    text: {
      primary: "#2281D0",
    },
  },
});

interface Props {
  pageStore: TimelinePageStore;
}

function TopPeriodButton({ pageStore }: Props) {
  const onClickPeriod = (e: any) => {
    console.log(e.target.value);
    pageStore.setPeriod(e.target.value);
    pageStore.fetchChartData(e.target.value);
  };

  return (
    <Grid
      textAlign={"center"}
      style={{ marginTop: "24px", marginBottom: "16px" }}
    >
      <ThemeProvider theme={theme}>
        <ToggleButtonGroup
          value={pageStore.period}
          exclusive
          onChange={onClickPeriod}
          sx={{
            "& .MuiToggleButton-root": {
              borderRadius: "5px", // 각 버튼의 radius 값
              margin: "0 10px", // 버튼 간격
            },
            "& .MuiToggleButton-root:not(:first-of-type)": {
              borderLeft: "1px solid rgba(0, 0, 0, 0.1)",
              borderRadius: "5px",
            },
            "& .MuiToggleButton-root:not(:last-of-type)": {
              borderRadius: "5px",
            },
            "& .Mui-selected": {
              borderLeft: "1px solid #2281D0 !important",
            },
          }}
        >
          <StyledToggleButton value="last30day">Last 30 day</StyledToggleButton>
          <StyledToggleButton value="quarter">Quarter</StyledToggleButton>
          <StyledToggleButton value="half">Half</StyledToggleButton>
          <StyledToggleButton value="year">Year</StyledToggleButton>
        </ToggleButtonGroup>
      </ThemeProvider>
    </Grid>
  );
}

export default observer(TopPeriodButton);
